export const iframeAuthEn = {
  error: "Couldn't load this tool. Try reopening it from Hercules.",
  loading: 'Loading…',
}
